import React, { useEffect, useState } from "react";
import { Survey } from "./survey-types";
import { useOutletContext } from "react-router-dom";
import { SurveyResults } from "@/features/survey-results/survey-results-types";
import LoadingOverlay from "@/components/LoadingOverlay";
import AlertModal from "@/components/AlertModal";
import { storageService } from "@/services/StorageService";
import { SurveyAnalysis } from "../analyses/survey-analyses-types";
import { analyseSurveyResults } from "@/server/InsightsService";
import { SurveyAnalysisComponent } from "../analyses/SurveyAnalysisComponent";
import { FAKE_ANALYSIS } from "@/tmp/fake-analysis";

export const SurveyAnalysisTab: React.FC = () => {
  const { survey, results } = useOutletContext<{
    results: SurveyResults | undefined;
    survey: Survey | undefined;
  }>();
  const [loading, setLoading] = useState(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [analysis, setAnalysis] = useState<SurveyAnalysis | undefined>(
    undefined
  );

  useEffect(() => {
    if (!survey) {
      return;
    }
    storageService.getAnalysisBySurveyId(survey.id).then(setAnalysis);
  }, [survey]);

  async function handleAnalyseSurvey() {
    if (!survey || !results) {
      setAlertMessage("You reed to first compute the survey responses.");
      setIsAlertModalOpen(true);
      return;
    }
    setLoading(true);
    try {
      console.info("Answering survey");
      const analysis = await analyseSurveyResults(survey, results);
      console.info("Analyzed survey results", analysis);
      setAnalysis(analysis);
      storageService.saveSurveyAnalysis(analysis);
    } catch (error) {
      console.error("Error fetching data:", error);
      const errorMessage =
        (error instanceof Error ? error.message : String(error)) ||
        "Something went wrong. Check the console for more details.";
      setAlertMessage(errorMessage);
      setIsAlertModalOpen(true);
    } finally {
      setLoading(false);
    }
  }

  function mock() {
    setAnalysis(FAKE_ANALYSIS);
  }

  return (
    <div className="flex flex-col gap-4">
      {loading && <LoadingOverlay message="Analysing survey results..." />}
      {analysis && survey ? (
        <SurveyAnalysisComponent analysis={analysis} />
      ) : (
        <p className="mb-8">No analysis for this survey</p>
      )}
      <button className="btn-primary" onClick={handleAnalyseSurvey}>
        Analyse Survey
      </button>
      <button className="btn-primary" onClick={mock}>
        Fill with a fake analysis
      </button>

      <AlertModal
        isOpen={isAlertModalOpen}
        title="TwinVerse"
        message={alertMessage}
        onClose={() => setIsAlertModalOpen(false)}
      />
    </div>
  );
};
